import { render } from "./UniView.vue?vue&type=template&id=781cee9b"
import script from "./UniView.vue?vue&type=script&lang=js"
export * from "./UniView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__